import { Component, HostListener, Input, OnInit, ViewEncapsulation } from '@angular/core';
import * as $ from 'jquery';
import { Utility } from '../../shared/utility/utility';
window['$'] = window['jQuery'] = $;
@Component({
  selector: 'app-lobby-filter-group',
  templateUrl: './lobby-filter-group.component.html',
  styleUrls: ['./lobby-filter-group.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LobbyFilterGroupComponent implements OnInit {
  @Input() categoryType;
  @Input() lobbyDetails;
  @Input() showTabsList;
  @Input() gameProviderMap;
  @Input() currentGameGroupsList;
  windowType;
  headerWidth;
  @HostListener('window:resize') onResize() {
    this.deviceType();
  }

  @HostListener("window:scroll", ["$event"]) onWindowScroll() {
    if(this.windowType === "desktop") {
      this.onScroll();
    }
  }

  constructor(
    private utils: Utility
  ) { }

  ngOnInit(): void {
    this.deviceType();
  }

  deviceType() {
    this.headerWidth = $('.main_header').outerWidth();
    const ww = document.body.clientWidth;
    if (ww <= 992) {
      this.windowType = "mobile";
    } else {
      this.windowType = "desktop";
    }
  }
  
  onScroll() {
    let stickyParent = document.querySelector('#stickyParentWrapper') as HTMLElement;
    let stickyParentChild = document.querySelector('#stickyWrapper') as HTMLElement;
    if(stickyParent && stickyParentChild) {
      let stickyParentOffsetPos = stickyParent.offsetTop;
      let scrollPos = window.pageYOffset;
      if (scrollPos > stickyParentOffsetPos) {     
        stickyParentChild.classList.add('sticky');
      } else {             
        stickyParentChild.classList.remove('sticky');
      }
    }
  }
  
  showSearchBar() {
    this.utils.showSearchBar();
  }
}
